export const categories = [
  {
    slug: 'meishi',
    name: '美食',
    icon: 'ri-restaurant-line',
    description: '探索世界各地的甜蜜美食，从精致甜点到街头小吃',
    color: 'primary',
    cardImage: 'https://readdy.ai/api/search-image?query=Delicious%20Chinese%20desserts%20and%20sweet%20treats%20on%20a%20warm%20wooden%20table%2C%20soft%20natural%20lighting%2C%20minimal%20composition%2C%20food%20photography%20style%2C%20warm%20peach%20tones%2C%20elegant%20presentation%2C%20shallow%20depth%20of%20field&width=600&height=400&seq=category-meishi&orientation=landscape',
    headerImage: 'https://readdy.ai/api/search-image?query=Delicious%20Chinese%20desserts%20and%20sweet%20treats%20on%20a%20warm%20wooden%20table%2C%20soft%20natural%20lighting%2C%20minimal%20composition%2C%20food%20photography%20style%2C%20warm%20peach%20tones%2C%20elegant%20presentation%2C%20shallow%20depth%20of%20field&width=1800&height=560&seq=category-meishi-header&orientation=landscape',
  },
  {
    slug: 'lvxing',
    name: '旅行',
    icon: 'ri-earth-line',
    description: '跟着镜头环游世界，感受旅途中的温暖与美好',
    color: 'accent',
    cardImage: 'https://readdy.ai/api/search-image?query=Beautiful%20travel%20landscape%20with%20warm%20sunset%20light%2C%20scenic%20mountain%20view%2C%20peaceful%20natural%20scenery%2C%20soft%20golden%20tones%2C%20minimalist%20composition%2C%20dreamy%20atmosphere%2C%20travel%20photography&width=600&height=400&seq=category-lvxing&orientation=landscape',
    headerImage: 'https://readdy.ai/api/search-image?query=Beautiful%20travel%20landscape%20with%20warm%20sunset%20light%2C%20scenic%20mountain%20view%2C%20peaceful%20natural%20scenery%2C%20soft%20golden%20tones%2C%20minimalist%20composition%2C%20dreamy%20atmosphere%2C%20travel%20photography&width=1800&height=560&seq=category-lvxing-header&orientation=landscape',
  },
  {
    slug: 'mengchong',
    name: '萌宠',
    icon: 'ri-heart-pulse-line',
    description: '治愈系萌宠日常，猫咪狗狗的甜蜜可爱瞬间',
    color: 'secondary',
    cardImage: 'https://readdy.ai/api/search-image?query=Cute%20fluffy%20kitten%20and%20puppy%20playing%20together%20on%20a%20soft%20cream%20colored%20blanket%2C%20warm%20natural%20sunlight%2C%20adorable%20pet%20photography%2C%20soft%20focus%2C%20minimal%20composition%2C%20gentle%20pastel%20tones&width=600&height=400&seq=category-mengchong&orientation=landscape',
    headerImage: 'https://readdy.ai/api/search-image?query=Cute%20fluffy%20kitten%20and%20puppy%20playing%20together%20on%20a%20soft%20cream%20colored%20blanket%2C%20warm%20natural%20sunlight%2C%20adorable%20pet%20photography%2C%20soft%20focus%2C%20minimal%20composition%2C%20gentle%20pastel%20tones&width=1800&height=560&seq=category-mengchong-header&orientation=landscape',
  },
  {
    slug: 'qinggan',
    name: '情感',
    icon: 'ri-emotion-line',
    description: '分享温暖人心的故事，记录生活中的感动时刻',
    color: 'primary',
    cardImage: 'https://readdy.ai/api/search-image?query=Warm%20emotional%20moment%20between%20two%20people%20sharing%20a%20genuine%20smile%2C%20soft%20golden%20hour%20lighting%2C%20minimal%20composition%2C%20lifestyle%20photography%2C%20gentle%20atmosphere%2C%20warm%20peach%20tones&width=600&height=400&seq=category-qinggan&orientation=landscape',
    headerImage: 'https://readdy.ai/api/search-image?query=Warm%20emotional%20moment%20between%20two%20people%20sharing%20a%20genuine%20smile%2C%20soft%20golden%20hour%20lighting%2C%20minimal%20composition%2C%20lifestyle%20photography%2C%20gentle%20atmosphere%2C%20warm%20peach%20tones&width=1800&height=560&seq=category-qinggan-header&orientation=landscape',
  },
  {
    slug: 'shenghuo',
    name: '生活',
    icon: 'ri-home-heart-line',
    description: '发现日常生活中的小确幸，让每一天都充满甜蜜',
    color: 'accent',
    cardImage: 'https://readdy.ai/api/search-image?query=Cozy%20home%20interior%20with%20warm%20morning%20sunlight%2C%20fresh%20flowers%20on%20a%20wooden%20table%2C%20minimal%20lifestyle%20photography%2C%20soft%20natural%20lighting%2C%20cream%20and%20peach%20color%20palette%2C%20peaceful%20atmosphere&width=600&height=400&seq=category-shenghuo&orientation=landscape',
    headerImage: 'https://readdy.ai/api/search-image?query=Cozy%20home%20interior%20with%20warm%20morning%20sunlight%2C%20fresh%20flowers%20on%20a%20wooden%20table%2C%20minimal%20lifestyle%20photography%2C%20soft%20natural%20lighting%2C%20cream%20and%20peach%20color%20palette%2C%20peaceful%20atmosphere&width=1800&height=560&seq=category-shenghuo-header&orientation=landscape',
  },
  {
    slug: 'meirong',
    name: '美妆',
    icon: 'ri-palette-line',
    description: '潮流美妆教程与产品分享，解锁你的甜蜜妆容',
    color: 'secondary',
    cardImage: 'https://readdy.ai/api/search-image?query=Elegant%20beauty%20cosmetics%20arranged%20on%20a%20soft%20pink%20marble%20surface%2C%20natural%20lighting%2C%20minimal%20beauty%20photography%2C%20gentle%20pastel%20colors%2C%20clean%20composition%2C%20luxurious%20aesthetic&width=600&height=400&seq=category-meirong&orientation=landscape',
    headerImage: 'https://readdy.ai/api/search-image?query=Elegant%20beauty%20cosmetics%20arranged%20on%20a%20soft%20pink%20marble%20surface%2C%20natural%20lighting%2C%20minimal%20beauty%20photography%2C%20gentle%20pastel%20colors%2C%20clean%20composition%2C%20luxurious%20aesthetic&width=1800&height=560&seq=category-meirong-header&orientation=landscape',
  },
  {
    slug: 'yinyue',
    name: '音乐',
    icon: 'ri-music-line',
    description: '用旋律记录心情，发现触动心灵的好声音',
    color: 'primary',
    cardImage: 'https://readdy.ai/api/search-image?query=Vintage%20record%20player%20with%20vinyl%20on%20a%20warm%20wooden%20shelf%2C%20soft%20afternoon%20light%20streaming%20through%20curtains%2C%20nostalgic%20music%20lifestyle%20photography%2C%20warm%20amber%20tones%2C%20minimal%20composition&width=600&height=400&seq=category-yinyue&orientation=landscape',
    headerImage: 'https://readdy.ai/api/search-image?query=Vintage%20record%20player%20with%20vinyl%20on%20a%20warm%20wooden%20shelf%2C%20soft%20afternoon%20light%20streaming%20through%20curtains%2C%20nostalgic%20music%20lifestyle%20photography%2C%20warm%20amber%20tones%2C%20minimal%20composition&width=1800&height=560&seq=category-yinyue-header&orientation=landscape',
  },
  {
    slug: 'yundong',
    name: '运动',
    icon: 'ri-run-line',
    description: '健康生活方式分享，一起感受运动的快乐与活力',
    color: 'accent',
    cardImage: 'https://readdy.ai/api/search-image?query=Person%20practicing%20yoga%20in%20a%20bright%20airy%20studio%2C%20morning%20sunlight%2C%20minimal%20fitness%20photography%2C%20soft%20warm%20lighting%2C%20cream%20colored%20walls%2C%20peaceful%20atmosphere%2C%20clean%20composition&width=600&height=400&seq=category-yundong&orientation=landscape',
    headerImage: 'https://readdy.ai/api/search-image?query=Person%20practicing%20yoga%20in%20a%20bright%20airy%20studio%2C%20morning%20sunlight%2C%20minimal%20fitness%20photography%2C%20soft%20warm%20lighting%2C%20cream%20colored%20walls%2C%20peaceful%20atmosphere%2C%20clean%20composition&width=1800&height=560&seq=category-yundong-header&orientation=landscape',
  },
];

export const allVideos = [
  {
    id: 1,
    title: '夏日蜜桃冰沙，一口清凉整个夏天',
    category: 'meishi',
    author: '甜蜜小厨娘',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Cute%20Asian%20girl%20avatar%20portrait%20in%20warm%20lighting%2C%20soft%20smile%2C%20minimal%20style%2C%20simple%20background&width=120&height=120&seq=avatar-01&orientation=squarish',
    views: 128000,
    likes: 35600,
    duration: '02:35',
    thumbnail: 'https://readdy.ai/api/search-image?query=Refreshing%20peach%20smoothie%20in%20a%20tall%20glass%20with%20fresh%20peaches%20and%20mint%20leaves%20on%20a%20marble%20counter%2C%20bright%20summer%20sunlight%2C%20food%20photography%2C%20minimal%20composition%2C%20warm%20peach%20and%20cream%20tones&width=800&height=450&seq=thumb-01&orientation=landscape',
    description: '炎炎夏日，来一杯清凉解暑的蜜桃冰沙吧！选用新鲜成熟的蜜桃，搭配酸奶和蜂蜜，口感丝滑细腻，每一口都是夏天的味道。简单几步就能在家制作，快来试试吧！',
    content: '夏天到了，没有什么比一杯冰凉的蜜桃冰沙更能消暑解渴的了。今天分享的这个配方超级简单，只需要新鲜蜜桃、酸奶、蜂蜜和少许冰块。将所有食材放入搅拌机打匀，倒入杯中，顶部再放几片蜜桃装饰，一杯颜值与美味并存的夏日特饮就完成了！',
    tags: ['美食教程', '夏日饮品', '蜜桃', '自制冰沙'],
    publishDate: '2026-08-10',
  },
  {
    id: 2,
    title: '京都红叶季，漫步在秋日童话世界',
    category: 'lvxing',
    author: '旅行摄影师小王',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Young%20Asian%20man%20avatar%20portrait%20with%20camera%2C%20friendly%20smile%2C%20minimal%20style%2C%20simple%20warm%20background&width=120&height=120&seq=avatar-02&orientation=squarish',
    views: 256000,
    likes: 89200,
    duration: '05:12',
    thumbnail: 'https://readdy.ai/api/search-image?query=Beautiful%20autumn%20maple%20leaves%20in%20Kyoto%20Japan%2C%20traditional%20temple%20background%2C%20warm%20golden%20hour%20light%2C%20travel%20photography%2C%20vibrant%20red%20and%20orange%20foliage%2C%20dreamy%20atmosphere&width=800&height=450&seq=thumb-02&orientation=landscape',
    description: '秋天的京都，红叶如火，美得让人窒息。跟随我的镜头，一起漫步在清水寺、岚山的红叶隧道中，感受这份独属于秋日的浪漫与温暖。',
    content: '京都的红叶季从11月中旬开始，一直持续到12月初。最推荐的赏枫地点是清水寺和岚山。清晨的清水寺人少景美，阳光透过红叶洒在古老的木结构建筑上，画面温暖而宁静。岚山的竹林小径与红叶交相辉映，仿佛走进了童话世界。',
    tags: ['旅行', '京都', '红叶', '日本'],
    publishDate: '2026-08-08',
  },
  {
    id: 3,
    title: '小猫咪第一次见到雪，反应太可爱了',
    category: 'mengchong',
    author: '喵星人日记',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Cute%20cat%20lover%20avatar%20portrait%2C%20warm%20smile%2C%20minimal%20style%2C%20simple%20background&width=120&height=120&seq=avatar-03&orientation=squarish',
    views: 456000,
    likes: 125000,
    duration: '01:48',
    thumbnail: 'https://readdy.ai/api/search-image?query=Adorable%20orange%20tabby%20kitten%20playing%20in%20snow%20for%20the%20first%20time%2C%20curious%20expression%2C%20soft%20winter%20sunlight%2C%20cute%20pet%20photography%2C%20minimal%20composition%2C%20gentle%20pastel%20tones&width=800&height=450&seq=thumb-03&orientation=landscape',
    description: '南方长大的小橘猫第一次看到雪，又好奇又害怕的样子萌翻了！小心翼翼伸出爪子试探，结果一脚踩空滑倒，太治愈了！',
    content: '我家这只小橘猫从小在南方长大，今年冬天带它去北方旅行，第一次见到雪的样子真的太可爱了。它先是站在窗边看了好久，然后用爪子轻轻碰了一下玻璃上的雪花，最后我们带它出去，它在雪地里又蹦又跳，完全停不下来！',
    tags: ['萌宠', '猫咪', '冬日', '治愈'],
    publishDate: '2026-08-07',
  },
  {
    id: 4,
    title: '异地恋三年，今天终于等到你',
    category: 'qinggan',
    author: '温暖故事馆',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Gentle%20Asian%20woman%20avatar%20portrait%2C%20warm%20smile%2C%20minimal%20style%2C%20simple%20background&width=120&height=120&seq=avatar-04&orientation=squarish',
    views: 389000,
    likes: 156000,
    duration: '03:20',
    thumbnail: 'https://readdy.ai/api/search-image?query=Romantic%20reunion%20at%20train%20station%20with%20warm%20sunset%20light%2C%20emotional%20embrace%2C%20lifestyle%20photography%2C%20soft%20golden%20tones%2C%20minimal%20composition%2C%20heartwarming%20atmosphere&width=800&height=450&seq=thumb-04&orientation=landscape',
    description: '三年的异地恋，无数个思念的夜晚。今天终于在你所在的城市安了家，以后再也不分开了。这个视频记录了我们的重逢时刻，希望能温暖每一个在异地恋中的你。',
    content: '异地恋真的很不容易。三年里，我们靠着视频通话和偶尔的见面维系感情。有过争吵，有过怀疑，但更多的是对彼此的信任和坚持。今天我终于搬到了他的城市，在火车站见到他的那一刻，所有的等待都值得了。希望所有异地恋的情侣都能修成正果！',
    tags: ['情感', '异地恋', '重逢', '温暖'],
    publishDate: '2026-08-06',
  },
  {
    id: 5,
    title: '周末早晨的仪式感，一人食早餐分享',
    category: 'shenghuo',
    author: '小日子的美好',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Lifestyle%20blogger%20avatar%20portrait%2C%20gentle%20smile%2C%20minimal%20style%2C%20simple%20warm%20background&width=120&height=120&seq=avatar-05&orientation=squarish',
    views: 98000,
    likes: 28500,
    duration: '02:15',
    thumbnail: 'https://readdy.ai/api/search-image?query=Beautiful%20homemade%20breakfast%20spread%20on%20a%20wooden%20table%2C%20fresh%20bread%20eggs%20fruit%20and%20coffee%2C%20morning%20sunlight%2C%20minimal%20lifestyle%20photography%2C%20warm%20cream%20tones&width=800&height=450&seq=thumb-05&orientation=landscape',
    description: '周末的早晨不用赶时间，给自己做一顿精致的早餐。煎蛋、牛油果吐司、手冲咖啡，再加上窗外的阳光，这就是生活最美的样子。',
    content: '平时工作日总是匆匆忙忙，周末终于可以慢下来享受生活。今天分享我的周末早餐routine：先用磨豆机现磨咖啡豆，手冲一杯香浓的黑咖啡；然后煎一个溏心蛋，配上牛油果全麦吐司；最后切几片水果摆盘。整个过程大概20分钟，但带来的幸福感可以持续一整天！',
    tags: ['生活', '早餐', '仪式感', '美食'],
    publishDate: '2026-08-05',
  },
  {
    id: 6,
    title: '五分钟快速出门妆，新手也能学会',
    category: 'meirong',
    author: '美妆达人Lily',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Beauty%20blogger%20avatar%20portrait%2C%20fresh%20makeup%20look%2C%20minimal%20style%2C%20simple%20warm%20background&width=120&height=120&seq=avatar-06&orientation=squarish',
    views: 198000,
    likes: 67300,
    duration: '04:05',
    thumbnail: 'https://readdy.ai/api/search-image?query=Elegant%20makeup%20products%20arranged%20on%20a%20vanity%20table%20with%20soft%20natural%20light%2C%20minimal%20beauty%20photography%2C%20gentle%20peach%20and%20cream%20tones%2C%20clean%20composition&width=800&height=450&seq=thumb-06&orientation=landscape',
    description: '早上总是来不及化妆？这个五分钟快速出门妆教程帮你解决！只需五步：底妆、眉毛、眼影、腮红、口红，简单自然又好看。',
    content: '这个妆容的重点是"自然好气色"。底妆选择轻薄的BB霜即可，眉毛顺着自己的眉形轻轻填充，眼影用一个大地色单色就够，腮红打在苹果肌上增加元气感，最后涂一个温柔的豆沙色口红。整个流程不超过五分钟，但看起来精神又精致！',
    tags: ['美妆', '快速化妆', '日常妆', '教程'],
    publishDate: '2026-08-04',
  },
  {
    id: 7,
    title: '用一把尤克里里，弹唱属于我们的夏天',
    category: 'yinyue',
    author: '音乐小森林',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Musician%20avatar%20portrait%2C%20playing%20ukulele%2C%20warm%20expression%2C%20minimal%20style%2C%20simple%20background&width=120&height=120&seq=avatar-07&orientation=squarish',
    views: 145000,
    likes: 52000,
    duration: '03:42',
    thumbnail: 'https://readdy.ai/api/search-image?query=Ukulele%20on%20a%20wooden%20table%20by%20a%20sunny%20window%2C%20warm%20afternoon%20light%2C%20minimal%20music%20lifestyle%20photography%2C%20soft%20cream%20tones%2C%20peaceful%20atmosphere&width=800&height=450&seq=thumb-07&orientation=landscape',
    description: '夏天、海风、尤克里里。学会这首简单的小曲子，你也可以在朋友聚会时露一手。零基础也能学会，快拿起你的尤克里里吧！',
    content: '今天教大家弹唱一首超简单的夏日小曲，只需要三个和弦：C、G、Am。右手用最简单的下扫节奏就可以了。这首歌的旋律轻快明朗，歌词也非常适合夏天，学会之后不管是露营还是海边聚会都可以拿出来表演！',
    tags: ['音乐', '尤克里里', '弹唱', '教程'],
    publishDate: '2026-08-03',
  },
  {
    id: 8,
    title: '居家燃脂训练，每天15分钟告别小肚腩',
    category: 'yundong',
    author: '活力健身教练',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Fitness%20coach%20avatar%20portrait%2C%20energetic%20smile%2C%20minimal%20style%2C%20simple%20background&width=120&height=120&seq=avatar-08&orientation=squarish',
    views: 267000,
    likes: 89000,
    duration: '06:30',
    thumbnail: 'https://readdy.ai/api/search-image?query=Person%20doing%20home%20workout%20in%20a%20bright%20airy%20living%20room%2C%20morning%20sunlight%2C%20minimal%20fitness%20photography%2C%20warm%20cream%20tones%2C%20clean%20composition&width=800&height=450&seq=thumb-08&orientation=landscape',
    description: '不用去健身房，在家就能完成的燃脂训练！15分钟高强度间歇训练，针对腹部核心，坚持一周就能看到效果。',
    content: '这套居家燃脂训练包含5个动作：开合跳、高抬腿、平板支撑、卷腹和俄罗斯转体。每个动作做40秒，休息20秒，循环3组。不需要任何器械，只需要一张瑜伽垫。建议每天早上空腹做效果最好，坚持两周你会发现腰围明显缩小！',
    tags: ['运动', '健身', '燃脂', '居家训练'],
    publishDate: '2026-08-02',
  },
  {
    id: 9,
    title: '手工草莓酱的制作秘诀，留住春天的味道',
    category: 'meishi',
    author: '甜蜜小厨娘',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Cute%20Asian%20girl%20avatar%20portrait%20in%20warm%20lighting%2C%20soft%20smile%2C%20minimal%20style%2C%20simple%20background&width=120&height=120&seq=avatar-01&orientation=squarish',
    views: 89000,
    likes: 31200,
    duration: '03:55',
    thumbnail: 'https://readdy.ai/api/search-image?query=Homemade%20strawberry%20jam%20in%20a%20glass%20jar%20with%20fresh%20strawberries%20on%20a%20wooden%20table%2C%20soft%20natural%20light%2C%20food%20photography%2C%20minimal%20composition%2C%20warm%20peach%20tones&width=800&height=450&seq=thumb-09&orientation=landscape',
    description: '又到了草莓季，自己动手做一瓶纯天然无添加的草莓酱吧！配面包、酸奶都超级好吃，做法简单到不可思议。',
    content: '自制草莓酱只需要三样东西：新鲜草莓、白砂糖和柠檬汁。草莓洗净切块，和糖按2:1的比例放入锅中，小火慢慢熬煮。期间要不停搅拌防止糊底。等果酱变得浓稠时加入柠檬汁，再煮两分钟就可以装瓶了。趁热装入消毒过的玻璃瓶，倒扣放凉，可以保存三个月！',
    tags: ['美食教程', '草莓酱', '手工', '烘焙'],
    publishDate: '2026-08-01',
  },
  {
    id: 10,
    title: '大理洱海边的慢时光，治愈系旅行Vlog',
    category: 'lvxing',
    author: '旅行摄影师小王',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Young%20Asian%20man%20avatar%20portrait%20with%20camera%2C%20friendly%20smile%2C%20minimal%20style%2C%20simple%20warm%20background&width=120&height=120&seq=avatar-02&orientation=squarish',
    views: 312000,
    likes: 98000,
    duration: '07:20',
    thumbnail: 'https://readdy.ai/api/search-image?query=Beautiful%20Erhai%20Lake%20in%20Dali%20Yunnan%20at%20sunset%2C%20traditional%20white%20buildings%2C%20peaceful%20water%20reflection%2C%20travel%20photography%2C%20warm%20golden%20hour%20light%2C%20dreamy%20atmosphere&width=800&height=450&seq=thumb-10&orientation=landscape',
    description: '逃离城市的喧嚣，来到大理洱海边。在这里，时间好像变慢了。骑车环湖、喝杯咖啡、看日落，这就是我想要的旅行。',
    content: '大理真的是一个让人来了就不想走的地方。这次旅行我选择住在洱海边的一家民宿，每天早上被阳光和鸟叫声唤醒。白天租一辆电动车环湖，沿途的风景美得让人说不出话。傍晚坐在洱海边的咖啡馆，看着太阳慢慢沉入湖面，感觉所有的烦恼都被治愈了。',
    tags: ['旅行', '大理', '洱海', 'Vlog'],
    publishDate: '2026-07-30',
  },
  {
    id: 11,
    title: '狗狗的暖心守护，主人伤心时的感人反应',
    category: 'mengchong',
    author: '毛孩子日记',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Pet%20owner%20avatar%20portrait%2C%20warm%20and%20friendly%2C%20minimal%20style%2C%20simple%20background&width=120&height=120&seq=avatar-09&orientation=squarish',
    views: 523000,
    likes: 198000,
    duration: '02:10',
    thumbnail: 'https://readdy.ai/api/search-image?query=Golden%20retriever%20comforting%20its%20owner%20with%20a%20gentle%20paw%2C%20warm%20home%20interior%2C%20emotional%20pet%20photography%2C%20soft%20evening%20light%2C%20heartwarming%20atmosphere&width=800&height=450&seq=thumb-11&orientation=landscape',
    description: '当主人情绪低落假装哭泣时，金毛的反应让人泪目。它立刻放下玩具跑过来，用爪子轻轻拍着主人，还不停地舔主人的脸。狗狗真的是人类最好的朋友。',
    content: '那天心情不太好，坐在沙发上发呆。我家金毛本来在玩它的玩具球，看到我情绪不对，立刻放下球跑过来。它先是用头蹭了蹭我的手，然后趴在我腿上，用那双充满关怀的大眼睛看着我。那一刻真的被治愈了，狗狗的爱就是这么纯粹无条件的。',
    tags: ['萌宠', '狗狗', '治愈', '感人'],
    publishDate: '2026-07-29',
  },
  {
    id: 12,
    title: '写给五年后的自己：愿你依然热爱生活',
    category: 'qinggan',
    author: '温暖故事馆',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Gentle%20Asian%20woman%20avatar%20portrait%2C%20warm%20smile%2C%20minimal%20style%2C%20simple%20background&width=120&height=120&seq=avatar-04&orientation=squarish',
    views: 176000,
    likes: 72000,
    duration: '04:30',
    thumbnail: 'https://readdy.ai/api/search-image?query=Person%20writing%20a%20letter%20by%20a%20sunny%20window%2C%20warm%20afternoon%20light%2C%20minimal%20lifestyle%20photography%2C%20soft%20cream%20tones%2C%20peaceful%20atmosphere&width=800&height=450&seq=thumb-12&orientation=landscape',
    description: '深夜录下这段视频，想对五年后的自己说几句话。希望那时候的你，依然记得此刻的初心，依然对生活充满期待和热爱。',
    content: '亲爱的五年后的我，你现在过得好吗？是否还记得五年前这个深夜，我坐在书桌前给你录下这段话。我希望你已经实现了那些小小的梦想，也希望你没有忘记，生活中最重要的不是成功，而是每一天都能感受到幸福和满足。无论你在哪里，都要记得爱自己。',
    tags: ['情感', '成长', '生活感悟', '温暖'],
    publishDate: '2026-07-28',
  },
];

export const creators = [
  {
    name: '甜蜜小厨娘',
    avatar: 'https://readdy.ai/api/search-image?query=Cute%20Asian%20girl%20portrait%20in%20warm%20kitchen%20setting%2C%20bright%20smile%2C%20minimal%20style%2C%20soft%20lighting%2C%20simple%20warm%20background&width=200&height=200&seq=creator-01&orientation=squarish',
    followers: 1280000,
    videos: 326,
    description: '热爱美食与生活，用镜头记录每一道治愈系美食',
    tags: ['美食', '烘焙', '生活'],
  },
  {
    name: '旅行摄影师小王',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Asian%20man%20portrait%20with%20camera%20in%20scenic%20location%2C%20friendly%20smile%2C%20minimal%20style%2C%20soft%20natural%20lighting%2C%20simple%20background&width=200&height=200&seq=creator-02&orientation=squarish',
    followers: 965000,
    videos: 218,
    description: '用镜头丈量世界，分享旅途中的每一个美好瞬间',
    tags: ['旅行', '摄影', 'Vlog'],
  },
  {
    name: '喵星人日记',
    avatar: 'https://readdy.ai/api/search-image?query=Cat%20lover%20portrait%20with%20cat%2C%20warm%20and%20cozy%2C%20minimal%20style%2C%20soft%20lighting%2C%20simple%20background&width=200&height=200&seq=creator-03&orientation=squarish',
    followers: 856000,
    videos: 412,
    description: '铲屎官一枚，记录猫主子的每一个可爱日常',
    tags: ['萌宠', '猫咪', '日常'],
  },
  {
    name: '温暖故事馆',
    avatar: 'https://readdy.ai/api/search-image?query=Gentle%20Asian%20woman%20portrait%20in%20cozy%20setting%2C%20warm%20smile%2C%20minimal%20style%2C%20soft%20lighting%2C%20simple%20background&width=200&height=200&seq=creator-04&orientation=squarish',
    followers: 723000,
    videos: 156,
    description: '用声音温暖你，分享这个世界上最动人的故事',
    tags: ['情感', '故事', '温暖'],
  },
  {
    name: '小日子的美好',
    avatar: 'https://readdy.ai/api/search-image?query=Lifestyle%20blogger%20portrait%20in%20beautiful%20home%20setting%2C%20gentle%20smile%2C%20minimal%20style%2C%20soft%20warm%20lighting%2C%20simple%20background&width=200&height=200&seq=creator-05&orientation=squarish',
    followers: 590000,
    videos: 285,
    description: '在日常中发现美好，分享小而精致的生活方式',
    tags: ['生活', '家居', '仪式感'],
  },
  {
    name: '音乐小森林',
    avatar: 'https://readdy.ai/api/search-image?query=Musician%20portrait%20with%20guitar%20in%20warm%20setting%2C%20gentle%20expression%2C%20minimal%20style%2C%20soft%20lighting%2C%20simple%20background&width=200&height=200&seq=creator-06&orientation=squarish',
    followers: 445000,
    videos: 198,
    description: '用旋律治愈心灵，一把吉他走天下的音乐旅人',
    tags: ['音乐', '弹唱', '原创'],
  },
];

export const faqData = [
  {
    question: '蜜桃视频是什么？',
    answer: '蜜桃视频是一款专注甜蜜生活方式的短视频平台。我们汇聚了美食、旅行、萌宠、情感、生活、美妆、音乐、运动等海量优质内容，致力于为用户打造一个温暖、治愈、积极向上的短视频社区。在这里，你可以发现生活中的美好，也可以分享属于自己的精彩瞬间。',
  },
  {
    question: '如何下载蜜桃视频APP？',
    answer: '您可以在苹果App Store或各大安卓应用商店（如华为应用市场、小米应用商店、应用宝等）搜索"蜜桃视频"下载我们的官方APP。也可以在官网首页扫描二维码直接下载。APP支持iOS 12.0以上和Android 8.0以上系统版本。',
  },
  {
    question: '蜜桃视频如何成为创作者？',
    answer: '成为蜜桃视频创作者非常简单！下载APP后，使用手机号注册账号，点击底部"+"按钮即可开始创作。我们为新创作者提供了丰富的创作工具，包括智能剪辑、滤镜特效、背景音乐库等。优质内容还有机会获得官方推荐和流量扶持！',
  },
  {
    question: '蜜桃视频的内容审核标准是什么？',
    answer: '我们严格遵守国家法律法规和社会主义核心价值观，建立了完善的内容审核机制。所有上传内容均经过AI+人工双重审核，确保平台内容的健康、安全、优质。我们坚决抵制低俗、暴力、虚假等不良内容，致力于维护清朗的网络空间。',
  },
  {
    question: '蜜桃视频如何保护用户隐私？',
    answer: '用户隐私保护是我们的首要任务。蜜桃视频遵循《个人信息保护法》等相关法律法规，采用业界领先的数据加密和安全防护技术。我们不会未经用户授权收集、使用或分享个人信息。详细的隐私政策可在APP"设置-隐私政策"中查看。',
  },
  {
    question: '蜜桃视频收费吗？',
    answer: '蜜桃视频对所有用户完全免费！观看视频、发布内容、互动评论等核心功能均不收取任何费用。我们通过广告和品牌合作维持运营，不会影响您的使用体验。未来如果推出增值服务，我们会提前告知并获得您的同意。',
  },
  {
    question: '海外用户可以注册使用蜜桃视频吗？',
    answer: '目前蜜桃视频主要服务中国大陆用户。海外用户可以通过官网浏览部分公开内容，但受限于内容分发和版权协议，部分功能可能在海外无法正常使用。我们正在积极推进国际化布局，敬请期待！',
  },
  {
    question: '如何联系蜜桃视频的客服？',
    answer: '您可以通过以下方式联系我们：1）APP内"我的-帮助与反馈"提交问题；2）发送邮件至 support@mitaovideo.com；3）关注官方微信公众号"蜜桃视频"留言；4）拨打客服热线 400-888-6666（工作日9:00-18:00）。我们会在24小时内回复您的咨询。',
  },
];